import React, { Fragment } from 'react';

import PropTypes from 'prop-types';
import ErrorBoundary from '../../components/ErrorBoundary';

const PresentationLayout = props => {
  const { children } = props;

  return (
    <Fragment>
      <ErrorBoundary>
        {children}
      </ErrorBoundary>
    </Fragment>
  );
};

PresentationLayout.propTypes = {
  children: PropTypes.node
};

export default PresentationLayout;
